var l = Object.defineProperty;
var g = (i, e, s) => e in i ? l(i, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : i[e] = s;
var c = (i, e, s) => (g(i, typeof e != "symbol" ? e + "" : e, s), s);
var h = Object.defineProperty, p = (i, e, s) => e in i ? h(i, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : i[e] = s, r = (i, e, s) => (p(i, typeof e != "symbol" ? e + "" : e, s), s);
const u = "AppSystemClient";
class o {
  constructor(e, s) {
    r(this, "name"), r(this, "logger"), this.name = s, this.logger = e;
  }
  log(e, ...s) {
    this.logger(`${u}: ${this.name != null ? `[${this.name}]: ` : ""}${e}`, ...s);
  }
  createLogger(e) {
    return new o(this.logger, [this.name, e].filter((s) => s != null).join(":"));
  }
}
class m {
  constructor(e, s) {
    r(this, "messenger"), r(this, "apiName"), this.messenger = e, this.apiName = s;
  }
  on(e, s) {
    this.messenger.on(e, (t) => {
      var n;
      const { from: a } = t;
      a === this.apiName && ((n = s(t)) == null || n.catch(console.error));
    });
  }
  once(e, s) {
    this.messenger.once(e, (t) => {
      var n;
      const { from: a } = t;
      a === this.apiName && ((n = s(t)) == null || n.catch(console.error));
    });
  }
  off(e, s) {
    this.messenger.off(e, s);
  }
}
class f {
  constructor(e, s) {
    r(this, "apiMap", /* @__PURE__ */ new Map()), r(this, "logger"), r(this, "loadedPlugins", []), this.messenger = e, this.config = s, this.logger = (s == null ? void 0 : s.logger) ?? new o(console.debug.bind(console));
  }
  async initialize() {
    var e;
    for (const s of ((e = this.config) == null ? void 0 : e.plugins) ?? [])
      await this.installPlugin(s);
    await this.messenger.ready();
  }
  async connect(e) {
    await this.messenger.ready();
    const s = await this.messenger.connectApi(e);
    if (s == null)
      throw new Error(`The api is unknown or not registered by broker: ${e}`);
    return this.apiMap.set(e, s), {
      api: s,
      events: this.messenger.connectEvents(e)
    };
  }
  async disconnectApi(e) {
    this.apiMap.has(e) && (await this.messenger.disconnectApi(e), this.apiMap.delete(e));
  }
  async installPlugin(e) {
    await e.install(this), this.loadedPlugins.push(e);
  }
  registerApi(e, s) {
    this.messenger.registerApi(e, s);
  }
  unregisterApi(e) {
    this.messenger.unregisterApi(e);
  }
}
class y {
  constructor(e, s = Promise.resolve()) {
    c(this, "ctx");
    c(this, "readyPromise");
    this.ctx = e, this.readyPromise = s;
  }
  on(e, s) {
    this.ctx.messenger.on(e, s);
  }
  once(e, s) {
    this.ctx.messenger.once(e, s);
  }
  off(e, s) {
    this.ctx.messenger.off(e, s);
  }
  async connectApi(e) {
    var t, n;
    const s = await ((n = (t = this.ctx) == null ? void 0 : t.apis) == null ? void 0 : n.get(e));
    if (s != null)
      return s;
  }
  connectEvents(e) {
    return new m(this, e);
  }
  async disconnectApi(e) {
  }
  registerApi(e, s) {
    this.ctx.apis.register(e, s);
  }
  unregisterApi(e) {
    this.ctx.apis.unregister(e);
  }
  async ready() {
    await this.readyPromise;
  }
}
class w extends f {
  constructor(e, s) {
    super(new y(e), s);
  }
}
function d(i) {
  return {
    async install(e) {
      await new w(e, {
        plugins: [
          i
        ]
      }).initialize();
    },
    async uninstall() {
      var e;
      await ((e = i == null ? void 0 : i.uninstall) == null ? void 0 : e.call(i));
    }
  };
}
export {
  w as ScriptClientPluginAppSystemClient,
  d as createScriptProviderPlugin
};
//# sourceMappingURL=index.js.map
